export enum CheckoutRoutes {
  Card = '/checkout/card',
  DirectDebit = '/checkout/direct-debit',
  Ineligible = '/checkout/ineligible',
  MarketingPreferences = '/checkout/marketing-preferences',
  OrderConfirmation = '/checkout/order-confirmation',
  PaymentMethod = '/checkout/payment-method',
  PersonalDetails = '/checkout/personal-details',
  Root = '/checkout',
}
